module.exports = __webpack_public_path__ + "img/op.72ec5ddf.svg";